import { displayDate } from "../../../../../../utils/date.js";
import Button from "../../../../../common/buttons/Button.js";

const RowItems = ({ data, index, handleEditClick, handleconfirmation }) => {
  return (
    <>
      <td>
        <UserDetail text={data?.sno} />
      </td>

      <td>
        <UserDetail text={displayDate(data.date)} />
      </td>
      <td>
        <UserDetail text={data.template_name} />
      </td>

      <td></td>
      <td className="w-[250px]">
        <div className="flex items-center justify-center p-2.5 xl:p-2 col-span-full lg:col-span-1 gap-1 ">
          <Button
            type="secondary"
            className="text-bodySRB py-[8px]"
            onClick={() => handleEditClick(data)}
          >
            Edit
          </Button>
          <Button
            type="danger"
            className="text-bodySRB py-[8px]"
            onClick={() => handleconfirmation(data)}
          >
            Delete
          </Button>
        </div>
      </td>
    </>
  );
};

function UserDetail({ text, className, onCLick, onMouseEnter, onMouseLeave }) {
  return (
    <div
      onMouseEnter={onMouseEnter}
      onClick={onCLick}
      onMouseLeave={onMouseLeave}
      className={` ${className} py-4`}
    >
      <p className="text-bodySRB text-darkgrey">{text || "-"}</p>
    </div>
  );
}

export default RowItems;
